import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import Multiselect from "vue-multiselect";

export const showListMixin = {
  components: {
    VueGoodTable,
    Multiselect
  },
  data: () => {
    return {
      tableKey: 0,
      results: [],
      loading: true,
      formData: {},
      queryString: "",
      sortOptions: [
        { value: 'asc', label: 'Ascending (A-Z)' },
        { value: 'desc', label: 'Descending (Z-A' }
      ],
      tableData: {
        isLoading: true,
        rows: [],
        totalRows: 0,
        limit: 10,
        currentPage: 1,
        search: "",
        filterParams: "",
      }
    }
  },
  watch: {
    $route: "loadTableData",
  },
  created() {
    this.setDefaultDate();
    this.loadTableData();
  },
  computed: {
    getRole() {
      return this.$store.getters.getRole;
    },
  },
  methods: {
    resetTable() {
      this.tableData.currentPage = 1;
      this.tableData.search = "";
      this.tableData.filterParams = '';
      this.tableKey += 1;
      this.loadTableData();
    },
    numberFormat(number) {
      return new Intl.NumberFormat('en', {
        minimumFractionDigits: 2
      }).format(number)
    },
    deleteItem(id, name) {
      this.$swal({
        title: 'Delete ' + name,
        text: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        reverseButtons: true,
      }).then((res) => {
        if (res.value) {
          this.$store.commit("toggleLoading");
          this.$http
            .delete(process.env.VUE_APP_API_URL + this.$route.path + "/" + id)
            .then((res) => {
              this.$store.commit("toggleLoading");
              if (res.status == 200) {
                this.$swal({
                  title: "All done!",
                  text: res.data.message,
                  icon: "success"
                }).then(() => {
                  this.loadTableData()
                })
              }
            })
            .finally(() => { });
        }
      })
    },
    setDefaultDate() {
      this.formData.start_date = this.moment(new Date()).format("YYYY-MM-DD")
      this.formData.end_date = this.moment(new Date()).format("YYYY-MM-DD")
    },
    onPageChange(e) {
      this.tableData.currentPage = e.currentPage
      this.loadTableData()
    },
    onPerPageChange(e) {
      this.tableData.limit = e.currentPerPage
    },
    onColumnFilter(e) {
      this.tableData.filterParams = '';
      for (const [key, value] of Object.entries(e.columnFilters)) {
        if (value) {
          this.tableData.filterParams += '&' + key + '=' + value
        }
      }
      this.tableData.currentPage = 1
      this.loadTableData()
    },
    loadTableData() {
      const queryParams = this.$route.query;
      let searchParam = "";

      if (queryParams.search != undefined) {
        this.formData = { ...this.formData, ...this.$route.query };
        for (const key in queryParams) {
          searchParam += `&${key}=${queryParams[key]}`;
        }
      }

      this.tableData.isLoading = true;
      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            `${this.$route.path}?page=${this.tableData.currentPage}&limit=${this.tableData.limit}&sort_by=${this.tableData.sort_by}&sort_dir=${this.tableData.sort_dir}${searchParam}`
        )
        .then((res) => {
          this.tableData.rows = res.data.data;
          this.tableData.totalRows = res.data.total;
        })
        .finally(() => {
          this.tableData.isLoading = false;
        });
    },
  },
};